import { render } from "./BasicLayout.vue?vue&type=template&id=1130ee5c&scoped=true&ts=true"
import script from "./BasicLayout.vue?vue&type=script&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&lang=ts"

import "./BasicLayout.vue?vue&type=style&index=0&id=1130ee5c&lang=scss&scoped=true"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1130ee5c"]])

export default __exports__